import React from 'react';
import { NavItem } from './NavItem';
import type { NavGroupConfig, NavItemConfig } from './types';

export interface NavGroupProps {
  group: NavGroupConfig;
  pathname: string;
  collapsed: boolean;
  getBadge: (src: NavItemConfig['badgeSource']) => number | undefined;
}

function isActive(pathname: string, item: NavItemConfig): boolean {
  if (item.matchStartsWith) return pathname.startsWith(item.matchStartsWith);
  if (item.route === '/') return pathname === '/';
  return pathname.startsWith(item.route);
}

export const NavGroup: React.FC<NavGroupProps> = ({ group, pathname, collapsed, getBadge }) => {
  return (
    <div className="mb-4">
      {!collapsed && group.label && (
        <div className="px-4 mb-1 text-[10px] text-text-mute uppercase tracking-wider font-medium">
          {group.label}
        </div>
      )}
      {group.items.map((item) => (
        <NavItem
          key={item.key}
          item={item}
          active={isActive(pathname, item)}
          collapsed={collapsed}
          badge={getBadge(item.badgeSource)}
        />
      ))}
      {group.subGroups?.map((sub) => (
        <div key={sub.key} className={collapsed ? '' : 'mt-2'}>
          {!collapsed && (
            <div className="px-4 mb-0.5 text-[10px] text-text-mute/70 tracking-wide font-medium">
              {sub.label}
            </div>
          )}
          {sub.items.map((item) => (
            <NavItem
              key={item.key}
              item={item}
              active={isActive(pathname, item)}
              collapsed={collapsed}
              badge={getBadge(item.badgeSource)}
            />
          ))}
        </div>
      ))}
    </div>
  );
};
